import axiosWithTenant from '../utils/axiosHandler';

// Hardcoded API URL based on hostname
//TODO: remove this hardcoded API URL later
const getApiUrl = () => {
    const hostname = window.location.hostname;

    // Production domains
    if (hostname === 'lima.ac' || hostname.includes('lima.ac')) {
        return 'https://lima.ac/api';
    }
    if (hostname === 'lima.pitech.ca' || hostname.includes('lima.pitech.ca')) {
        return 'https://lima.pitech.ca/api';
    }
    if (hostname === 'bagbox.ca' || hostname.includes('bagbox.ca')) {
        return 'https://bagbox.ca/api';
    }

    // Development/localhost
    return 'http://localhost:80/api';
};

const API_URL = getApiUrl();

// Use the axiosWithTenant instance which includes tenant headers
const api = axiosWithTenant;

// DON'T set baseURL - it's already configured in axiosHandler
// api.defaults.baseURL = API_URL;

const subscriptionService = {
    /**
     * Check if user can perform an AI action
     * @param action - 'post' | 'analysis' | 'call' | 'image'
     */
    async canPerformAIAction(action) {
        try {
            const response = await api.get(`/api/subscriptions/check-quota/${action}`);
            return response.data;
        } catch (error) {
            console.error('Error checking quota:', error);

            // If it's a quota exceeded error (429), return the response
            if (error.response?.status === 429) {
                return error.response.data;
            }

            // For authentication errors
            if (error.response?.status === 401 || error.response?.status === 403) {
                return {
                    success: false,
                    allowed: false,
                    reason: 'Please log in to use AI features',
                    remaining: 0,
                    requiresUpgrade: false
                };
            }

            // For other errors (server errors, network issues, etc.)
            return {
                success: false,
                allowed: false,
                reason: 'Unable to check your AI quota right now. Please try again in a moment.',
                remaining: 0,
                requiresUpgrade: false
            };
        }
    },

    /**
     * Get user's quota summary
     */
    async getQuotaSummary(type = 'blog') {
        try {
            const response = await api.get('/api/subscriptions/quota-summary', {
                params: { type }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching quota summary:', error);
            return null;
        }
    },

    /**
     * Get all subscription plans
     */
    async getAllPlans(type = 'blog') {
        try {
            const response = await api.get('/api/subscriptions/plans', {
                params: { type }
            });
            return response.data || { plans: [] };
        } catch (error) {
            console.error('Error fetching subscription plans:', error);
            return { plans: [] };
        }
    },

    /**
     * Get user's current subscription
     */
    async getUserSubscription(type = 'blog') {
        try {
            const response = await api.get('/api/subscriptions/my-subscription', {
                params: { type }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching user subscription:', error);
            return null;
        }
    },

    /**
     * Create or update subscription
     */
    async createSubscription(planId, type = 'blog', paymentDetails = {}) {
        try {
            const response = await api.post('/api/subscriptions/create', {
                planId,
                type,
                paymentDetails
            });
            return response.data;
        } catch (error) {
            console.error('Create subscription error:', error.response?.data);
            throw new Error(error.response?.data?.message || 'Failed to create subscription');
        }
    },

    /**
     * Cancel subscription
     */
    async cancelSubscription(type = 'blog') {
        try {
            const response = await api.post('/api/subscriptions/cancel', { type });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to cancel subscription');
        }
    },

    /**
     * Record AI usage (internal)
     */
    async recordUsage(action, type = 'blog') {
        try {
            const response = await api.post('/api/subscriptions/record-usage', {
                action,
                type
            });
            return response.data;
        } catch (error) {
            console.error('Error recording usage:', error);
            throw error;
        }
    }
};

export default subscriptionService;


